module.exports = __webpack_public_path__ + "static/media/IMG-20200108-WA0011.eb8351e4.jpg";